// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2MkSQ","content":"styles_content__1rune","selectAll":"styles_selectAll__23UrU"};